import CircleSlider from '../3D/CircleSlider';
import { SliderProgress, SliderProgress__Item } from '../_app/cuchillo/components/SliderProgress';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import NoScroll from './NoScroll';

export default class Home extends NoScroll {
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
  }

  show__effect(__call) {
    Header.mode = "WHITE";
    Wrap.directShow();

    CircleSlider.getInstance().show();
    if (this.isFirstTime) {
      
      this.afterShow();
    } else {
      this.afterShow();
     
    }
  }

  afterShow() {
    super.afterShow();
  }

  hide__effect() {
    CircleSlider.getInstance().hide();
    Wrap.hide(() => { this.afterHide() }, {duration:.6});
  }

  beforeHide() {
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
  }
}

ControllerPage._addPage("home", Home)
